

































import "./goal-list.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import GoalCard from "./goal-card.vue";
import GoalCopy from "./goal-copy.vue";
import GoalSetup from "./goal-setup.vue";
import DeleteGoalModal from "./delete-goal-modal.vue";
import ArchiveGoalModal from "./archive-goal-modal.vue";

export default Vue.extend({
  name: "GoalList",
  components: {
    GoalCard,
    GoalCopy,
    GoalSetup,
    ArchiveGoalModal,
    DeleteGoalModal,
  },
  props: {
    selectedMemberId: {
      type: Number,
      default: NaN,
      required: true,
    },
    personalGoalFilter: {
      type: String,
      default: "All Targets",
      required: false,
    },
  },
  data() {
    return {
      showGoalCopy: false,
      showGoalSetup: false,
      showArchive: false,
      showDelete: false,
      copyingGoal: null,
      edittingGoal: {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: null,
        description: null,
        members: [],
        hashTags: null,
        grantedPermissions: [],
        gradeModel: null,
        calculationOption: NaN,
        completed: false,
        teams: [],
      },
      archiveOrDeleteGoal: null,
    };
  },
  computed: {
    ...mapState("session", ["user"]),
    personalGoalResults(): any {
      let groups = [];
      let allGoals = this.$store.state.goal.myGoals;
      let goals = allGoals || [];
      let hashTagFilter = null;

      if (this.selectedMemberId !== NaN) {
        goals = goals.filter(
          (goal) =>
            (goal.members && goal.members.filter((member) => member.memberId === this.selectedMemberId).length > 0) ||
            (goal.teams && goal.teams.filter((goalTeam) => goalTeam.teamMembers && goalTeam.teamMembers.filter((member) => member.memberId === this.selectedMemberId).length > 0).length > 0)
        );
      }

      let tags = [];
      if (this.personalGoalFilter && this.personalGoalFilter.startsWith("#")) {
        hashTagFilter = this.personalGoalFilter.replace("#", "");
        goals = goals.filter((goal) => goal.hashTagList && goal.hashTagList.filter((tag) => tag.text === hashTagFilter).length > 0);

        tags = [hashTagFilter];
      } else {
        if (this.personalGoalFilter === "Completed Targets") {
          goals = goals.filter((goal) => goal.completed === true);
        } else if (this.personalGoalFilter === "Active Targets") {
          goals = goals.filter((goal) => goal.completed === false);
        }

        tags = this.getHashTags(goals);
      }

      let noHashTagGoals = goals.filter((goal) => !goal.hashTagList || goal.hashTagList.length < 1);

      if (noHashTagGoals.length > 0) {
        groups.push({
          title: "No # Tags",
          goals: noHashTagGoals,
        });
      }

      tags = tags.sort();

      tags.forEach((hashTag) => {
        let tagedGoals = goals.filter((goal) => goal.hashTagList && goal.hashTagList.filter((tag) => tag.text === hashTag).length > 0);

        if (tagedGoals.length > 0) {
          groups.push({
            title: hashTag,
            goals: goals.filter((goal) => goal.hashTagList && goal.hashTagList.filter((tag) => tag.text === hashTag).length > 0),
          });
        }
      });

      if (groups.length == 0) {
        groups.push({
          title: "No # Tags",
          goals: [],
        });
      }

      return groups;
    },
  },
  methods: {
    getHashTags(goals) {
      let hashTags = [];
      goals.forEach((goal) => {
        hashTags = hashTags.concat(goal.hashTagList.map((tag) => tag.text));
      });
      return [...new Set(hashTags)];
    },
    encodeName(hashTag, name) {
      return `${hashTag}--${name}`;
    },
    showGoalCreator() {
      let user = (this as any).user;
      this.edittingGoal = {
        id: null,
        name: null,
        scope: null,
        timezoneOffset: NaN,
        timezoneName: null,
        timeline: [],
        description: null,
        calculationOption: 1,
        members: [{ memberId: user.id, memberName: user.nameName, memberEmailAddress: user.memberEmailAddress, memberAvatarImageUrl: user.memberAvatarImageUrl, role: 6, accepted: true }],
        hashTags: "",
        grantedPermissions: ["Bio.AssignAuthorRole", "Bio.AssignMember", "Bio.AssignFan"],
        gradeModel: JSON.stringify([
          { name: "Green", color: "#5EA95E", from: 70 },
          { name: "Yellow", color: "#FFAC2B", from: 31 },
          { name: "Red", color: "#F06849", from: 0 },
        ]),
        completed: false,
        teams: [],
      };
      this.showGoalSetup = true;
    },
    handleCancelGoalCopy() {
      this.showGoalCopy = false;
    },
    handleCancelNewGoal() {
      this.showGoalSetup = false;
    },
    showArchiveDialog(goal) {
      this.archiveOrDeleteGoal = goal;
      this.showArchive = true;
    },
    showDeleteDialog(goal) {
      this.archiveOrDeleteGoal = goal;
      this.showDelete = true;
    },
    markComplete(goal, completed) {
      goal.completed = completed;
      this.$store.dispatch("goal/update", { data: goal }).then(() => {});
    },
    handleDelete(action) {
      this.$store.dispatch("goal/delete", { data: this.archiveOrDeleteGoal }).then(() => {
        this.showDelete = false;
      });
    },
    handleRestore(goal) {
      this.$store.dispatch("goal/unarchive", { data: goal }).then((response) => {});
    },
    handleOpenGoalEditor(goal) {
      let startDate = goal.startDate ? new Date(goal.startDate) : null;
      let endDate = goal.endDate ? new Date(goal.endDate) : null;

      this.edittingGoal = {
        id: goal.id,
        name: goal.name,
        scope: goal.scope,
        timezoneOffset: goal.timezoneOffset,
        timezoneName: goal.timezoneName,
        timeline: [startDate, endDate],
        description: goal.description,
        members: goal.members,
        hashTags: goal.hashTags,
        grantedPermissions: goal.grantedPermissions,
        gradeModel: goal.gradeModel,
        calculationOption: goal.calculationOption,
        completed: goal.completed,
        teams: goal.teams,
      };

      this.showGoalSetup = true;
    },
    handleGoalCopy(goal) {
      let startDate = goal.startDate ? new Date(goal.startDate) : null;
      let endDate = goal.endDate ? new Date(goal.endDate) : null;

      this.copyingGoal = {
        id: goal.id,
        name: goal.name,
        scope: goal.scope,
        timezoneOffset: goal.timezoneOffset,
        timezoneName: goal.timezoneName,
        timeline: [startDate, endDate],
        description: goal.description,
        members: goal.members,
        hashTags: goal.hashTags,
        calculationOption: goal.calculationOption,
        gradeModel: goal.gradeModel,
      };

      this.showGoalCopy = true;
    },
  },
});
